import styled from "styled-components";
import {Popover} from 'antd';

import 'antd/lib/popover/style';

export const PopoverStyle = styled(Popover)`

`;